import { ExtractPropTypes, PropType } from 'vue';
import { BackgroundAttribute, ColorPickerOptions } from '../../../types';

export const defaultPackgroundData = {
  backgroundColor: '',
  backgroundImage: '',
  backgroundRepeat: 'no-repeat',
  backgroundPositionX: 'center',
  backgroundPositionY: 'center',
  backgroundSize: 'auto',
  backgroundAttachment: 'fixed',
  opacity: 1,
};

export const defaultColorPickerOptions = {
  shape: 'square',
  pureColor: '#ffffff',
  gradientColor: '',
  format: 'rgb',
  disableHistory: true,
  useType: 'pure',
  placement: 'auto',
};

export const backgroundProps = {
  backgroundData: {
    type: Object as PropType<BackgroundAttribute>,
    required: true,
  },
  fileUpload: Function,
  linkJump: Function,
  // 是否使用附件
  useAttachment: Boolean,
  labelCol: {
    type: Number as PropType<number>,
    default: 5,
  },
  wrapperCol: {
    type: Number as PropType<number>,
    default: 19,
  },
  // 拾色器配置
  colorPickerOptions: {
    type: Object as PropType<Partial<ColorPickerOptions>>,
    default: () => {
      return defaultColorPickerOptions;
    },
  },
};

export type BackgroundProps = Partial<ExtractPropTypes<typeof backgroundProps>>;
